export default __webpack_public_path__ + "static/media/4.5471f112.png";